import React, { Component } from 'react'
import { CardContent, Divider, Stack, Typography, Avatar, Paper } from '@mui/material'
import { Box } from '@mui/material';
import Grid from "@mui/material/Grid";
import HomeEnergyIcon from "../images/home-energy.png";
import FoodImage from "../images/food.png";
import ClothImage from "../images/cloth.png";
import ArticImage from "../images/artic.png";
import { GradientButton } from "../components/ui-components/GradientButton";
import { getURLBase } from '../utils/helperFns';
import axios from 'axios';

const images = {
    ClothImage: ClothImage,
    FoodImage: FoodImage,
}

export default class ReduceCarbonFootprint extends Component {
    constructor(props) {
        super(props);
        this.url = getURLBase(true) + "/carbon-footprint/reduce";
        this.state = {
            "reduced_this_year": 0,
            "reduce": 0,
            "save": 0,
            "merchants": []
        }
    }
    // componentDidMount() {
    //     axios.post(this.url, { gid: this.props.gid }).then(
    //         (response) => {
    //             this.setState({
    //                 "reduced_this_year": response.data.body.reduced_this_year,
    //                 "reduce": response.data.body.reduce,
    //                 "save": response.data.body.save,
    //                 "merchants": response.data.body.merchants
    //             })
    //         }
    //     )
    // }
    render() {
        return (
            <Box className="widgetCard cardShadow">
                <Typography variant="h4" sx={{ fontWeight: 700 }} gutterBottom align="center">
                    Reduce Your Carbon Footprint
                </Typography>
                <Divider light />
                <CardContent sx={{ marginTop: 3, paddingBottom: 4 }}>
                    <Grid container justifyContent="center" marginY={2}>
                        <Grid item md={6} sm={8} xs={12}>
                            <Typography alignItems="end" justifyContent="center" display="flex" gap={1} fontWeight={700} marginBottom={4} variant="h5" align="center">
                                Reduced this year
                                <Typography vaiant="caption" color="text.secondary">
                                    over same period last year
                                </Typography>
                            </Typography>

                            <Typography alignItems="end" justifyContent="center" display="flex" gap={1} fontWeight={800} marginBottom={4} variant="h3" align="center">
                                {this.state.reduced_this_year}
                                <Typography vaiant="body1">
                                    tonne CO₂
                                </Typography>
                            </Typography>
                        </Grid>
                    </Grid>
                    <Divider light />
                    <Grid container justifyContent="center" marginY={2}>
                        <Grid item md={7} sm={8} xs={12}>
                            <Stack gap={1} marginBottom={4} direction="row" alignItems="center" justifyContent="center">
                                <Typography variant="h5" fontWeight={700} align="center">
                                    Home Energy
                                </Typography>

                                <Avatar sx={{ bgcolor: "#CDDC39", width: 50, height: 50 }} >
                                    <img src={HomeEnergyIcon} height="75%" width="75%" />
                                </Avatar>
                            </Stack>


                            <Grid container rowGap={2} marginBottom={4}>
                                <Grid item xs={4}>
                                    <Typography variant="h6">
                                        Reduce
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography variant="h4">
                                        {this.state.reduce}
                                        <Typography display="inline-block" ml={1} variant="body1">
                                            tonnes CO₂ per year
                                        </Typography>
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container rowGap={2} marginBottom={4}>
                                <Grid item xs={4}>
                                    <Typography variant="h6">
                                        Save
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Stack direction="row" gap={2}>
                                        <img src={ArticImage} height={48} width={48} alt="save artic ice" />
                                        <Typography variant="h4">
                                            {this.state.save}
                                            <Typography display="inline" ml={1} variant="body1">
                                                sq meters of Arctic sea ice
                                                from melting every year
                                            </Typography>
                                        </Typography>
                                    </Stack>

                                </Grid>
                            </Grid>

                            <Box textAlign="center" sx={{ textTransform: "capitalize !important" }} marginTop={4} marginBottom={4}>
                                <GradientButton textTransformtype="capitalize">
                                    Reduce your carbon Footprint
                                </GradientButton>
                            </Box>

                        </Grid>
                    </Grid>
                    <Divider light />
                    <Grid container justifyContent="center" marginY={2}>
                        <Grid item md={6} sm={8} xs={12}>
                            <Typography alignItems="end" justifyContent="center" display="flex" gap={1} fontWeight={700} marginBottom={4} variant="h5" align="center">
                                Merchants
                            </Typography>

                            <Grid container marginY={4} columnSpacing={2} rowSpacing={2} justifyContent={"center"}>

                                {/* {
                                    this.state.merchants.map((merchant, index) => {
                                        return (

                                            <Grid item sm={6} xs={10} display="flex" width="100%" key={index}>
                                                <Paper elevation={10} sx={{ padding: 2, width: "100%" }}>
                                                    <Typography variant="h6" align="center" gutterBottom>
                                                        {merchant.title}
                                                    </Typography>

                                                    <img style={{ objectFit: 'contain' }} height={120} width="100%" src={images[merchant.img]} alt="Food merchants" />
                                                </Paper>
                                            </Grid>
                                        )
                                    })
                                } */}

<Grid item sm={6} xs={10} display="flex" width="100%">
                                <Paper elevation={10} sx={{padding:2,width:"100%"}}>
                                    <Typography variant="h6" align="center" gutterBottom>
                                        Food
                                    </Typography>

                                    <img style={{objectFit:'contain'}} height={120} width="100%" src={FoodImage} alt="Food merchants" />
                                </Paper>
                                </Grid>
                                <Grid item sm={6} xs={10} display="flex" width="100%">
                                <Paper elevation={8} sx={{padding:2,width:"100%"}}>
                                    <Typography variant="h6" align="center" gutterBottom>
                                        Clothes
                                    </Typography>

                                    <img style={{objectFit:'contain'}} height={120} width="100%" src={ClothImage} alt="Food merchants" />
                                </Paper>
</Grid>


                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>

            </Box>
        )
    }
}
